// Fecha o modal só num clique DE VERDADE no fundo: o mouse tem que descer E
// subir sobre o próprio backdrop. Sem isso, arrastar pra selecionar texto
// dentro do modal e soltar o botão fora fechava a tela no meio da ação — o
// `click` do navegador dispara no ancestral comum (o fundo) mesmo tendo
// começado lá dentro.
//
// Não é hook (não usa useRef): guarda o estado numa propriedade do próprio
// elemento, via `currentTarget`. Assim pode ser chamado depois de um early
// return sem violar as regras de hooks.
//
// Uso: <div {...backdropClose(onClose)}> … conteúdo … </div>
export default function backdropClose(onClose) {
  return {
    onMouseDown: (e) => {
      if (e.target === e.currentTarget) e.currentTarget.dataset.pressBackdrop = '1';
    },
    onClick: (e) => {
      const desceuNoFundo = e.currentTarget.dataset.pressBackdrop === '1';
      delete e.currentTarget.dataset.pressBackdrop;
      if (e.target === e.currentTarget && desceuNoFundo) onClose();
    },
  };
}
